import { ICONS } from 'src/utils/icons';

// ----------------------------------------------------------------------

export const _account = [
  {
    label: 'Home',
    href: '/',
    icon: ICONS.app,
  },
];
